// src/utilities/facebookPixel/index.ts

let ReactPixel: any = null;

const getPixel = async () => {
  if (typeof window === "undefined") return null;

  if (!ReactPixel) {
    const mod = await import("react-facebook-pixel");
    ReactPixel = mod.default ?? mod;
  }

  return ReactPixel;
};

export const initFacebookPixel = async () => {
  const pixel = await getPixel();
  if (!pixel) return;

  pixel.init("807266366100667"); // thals usd
  pixel.pageView();
  console.log("pixel initialized");
};

export const handleDonateClick = async () => {
  const pixel = await getPixel();
  if (!pixel) return;

  pixel.track("Donate Online", {
    value: 1,
    currency: "USD",
  });
};

export const handleDonationInitiated = async () => {
  const pixel = await getPixel();
  if (!pixel) return;

  pixel.track("InitiateCheckout", {
    value: 1,
    currency: "USD",
  });
};

export const handleDonationSuccess = async () => {
  const pixel = await getPixel();
  if (!pixel) return;

  pixel.track("Purchase", {
    value: 1,
    currency: "USD",
  });
};